import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AppUtil } from '../../../../utils/app.util';
import { LoadTypeEnum } from '@cai-services';

@Component({
  selector: 'cai-load-type-switch',
  templateUrl: './load-type-switch.component.html',
  styleUrls: ['./load-type-switch.component.scss'],
  standalone: false,
})
export class CaiLoadTypeSwitchComponent {
  @Input() mode: LoadTypeEnum;
  @Output() onModeChange = new EventEmitter<LoadTypeEnum>();

  LoadTypeEnum = LoadTypeEnum;
  isHKIACargo = AppUtil.isHKIAWhiteLabel();

  constructor(private readonly cdr: ChangeDetectorRef) {}

  selectMode(mode: LoadTypeEnum) {
    if (this.mode !== mode) {
      this.onModeChange.emit(mode);
      this.cdr.detectChanges();
    }
  }
}
